import React from 'react';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import queryString from 'qs';
import classNames from 'classnames';

const PaginationButton = ({ className, children, onClick, href }) => {
  const history = useHistory();
  const clickHandler = (e) => {
    onClick(e);
    history.push(href);
  };
  return (
    <button role="button" className={className} onClick={clickHandler}>
      {children}
    </button>
  );
};
/**
 *  Component for loading more search content in a list.
 *  Uses withRouter from react-router to read window location.
 *
 *  Send additional query params with the prop `qsModifiers`.
 *
 *  We can override react router functionality with the prop
 *  `useReactRouterLink=false` (default = true) then we use <a> element
 *  and not <Link> component.
 *
 *
 */
const Pagination = (props) => {
  if (!props.NextPage) return null;
  const options = {
    ignoreQueryPrefix: true,
  };
  const qs = {
    ...queryString.parse(props.location.search, options),
    p: props.NextPage,
    ...props.qsModifiers,
  };

  const qStringify = queryString.stringify(qs);

  const paginationClass = classNames({
    'c-pagination': true,
    'c-pagination--is-loading': props.isLoading,
    ...props.Modifiers,
  });

  const href = `${props.location.pathname}?${qStringify}`;

  if (props.useReactRouterLink) {
    return (
      <PaginationButton
        onClick={props.onClick}
        className={paginationClass}
        href={href}
      >
        <span className="c-pagination__text">{props.children}</span>
        {props.Spinner}
      </PaginationButton>
    );
  }

  return (
    <a className={paginationClass} href={href}>
      <span className="c-pagination__text">{props.children}</span>
    </a>
  );
};

Pagination.defaultProps = {
  useReactRouterLink: true,
  qsModifiers: {},
};

const ShowAll = (props) => {
  if (!props.ShowTotalText) {
    return null;
  }
  if (props.NextPage === null) {
    return null;
  }

  const qs = queryString.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  const qStringify = queryString.stringify({
    q: qs.q,
    p: 1,
    batchsize: props.TotalHits,
    ...props.qsModifiers,
    theme: qs.theme,
  });
  return (
    <a
      className="c-pagination c-pagination__showall"
      href={`${props.location.pathname}?${qStringify}`}
    >
      {props.ShowTotalText}
    </a>
  );
};

ShowAll.defaultProps = {
  NextPage: null, // no need for "undefined" check if not in response.
  qsModifiers: {},
};

export { ShowAll };

export default withRouter(Pagination);
